import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, switchMap } from 'rxjs';
import { AccessRightsService } from '../../access-rights/access-right.service';
import { AppAuthService } from '../app-auth.service';

/**
 * make sure user is authenticated, redirect to login if not athenticated
 * @param route
 * @param state
 * @returns
 */
export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AppAuthService);
  const routerService = inject(Router);

  return authService.isAuthenticated().pipe(
    map(res => {
      if (!res) {
        authService.setPostLoginRedirectUrl(window.location.href);
        routerService.navigateByUrl('/login');
        return false;
      }
      return true;
    }),
    catchError((err) => {
      console.log(err);
      return of(false);
    })
  );
};

export const loadAccessRightsGuard: CanActivateFn = (route, state) => {
  const authService = inject(AppAuthService);
  const accessRightsService = inject(AccessRightsService);

  return authService.isAuthenticated().pipe(
    switchMap(isAuth => {
      if (!isAuth) {
        return of(false);
      }

      return accessRightsService.getAccessRights().pipe(
        catchError((err) => {
          console.log(err);
          return of(false);
        })
      );
    })
  );
};

// export const loadAccessRightsGuard: CanActivateFn = (route, state) => {

//   const authService = inject(AppAuthService);
//   const accessRightsService = inject(AccessRightsService);

//   return authService.isAuthenticated().pipe(
//     switchMap(isAuth => {

//       if (!isAuth) {
//         return of(false);
//       }

//       return accessRightsService.getAccessRights().pipe(
//         map(res => {
//           return true;
//         }),
//         catchError((err) => {
//           console.log(err);
//           return of(false);
//         })
//       );
//     })
//   );
// };
